import { render, staticRenderFns } from "./WagonWheelsetInput.vue?vue&type=template&id=68714496&scoped=true"
import script from "./WagonWheelsetInput.vue?vue&type=script&lang=js"
export * from "./WagonWheelsetInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68714496",
  null
  
)

export default component.exports